import { useTranslations } from '@/i18n/use-translations';
import Widget from '@/components/common/widget.tsx';
import { useMemo } from 'react';
import { getOrderedEventCatalogKeysForUi } from '@/constants/product-catalog.ts';
import EventCatalogProduct from '@/components/events/event-catalog/event-catalog-product.tsx';
import { useCatalogDisplayFeatureAccess, useFeatureAccess } from '@/hooks/use-feature-access';
import { catalogUsesDisplayFeatureFlags } from '@/constants/product-catalog.ts';
import { useProductsStore } from '@/state/stores/use-products-store.ts';
import { EVENT_CATALOG_ORDERS_FEATURE } from '@/constants/feature-flags';

export default function Features() {
  const t = useTranslations();
  const { hasAccess: hasMonetizeAccess, isLoading: monetizeAccessLoading } = useFeatureAccess('monetize');
  const { hasAccess: hasCatalogOrderAccess, isLoading: catalogOrderAccessLoading } =
    useFeatureAccess(EVENT_CATALOG_ORDERS_FEATURE);
  const { featureAccess, isLoading: catalogFlagsLoading } = useCatalogDisplayFeatureAccess();
  const storeProducts = useProductsStore((s) => s.products);
  const gateCatalogFlags = catalogUsesDisplayFeatureFlags();
  const visibleCatalogKeys = useMemo(
    () => getOrderedEventCatalogKeysForUi(storeProducts, { featureAccess }),
    [storeProducts, featureAccess],
  );

  if (
    monetizeAccessLoading ||
    catalogOrderAccessLoading ||
    !hasMonetizeAccess ||
    !hasCatalogOrderAccess ||
    (gateCatalogFlags && catalogFlagsLoading)
  ) {
    return null;
  }

  return (
    <Widget title={t('event.features.dashboardDescription')}>
      {visibleCatalogKeys.map((productKey) => (
        <EventCatalogProduct key={productKey} productKey={productKey} />
      ))}
    </Widget>
  );
}
